import proofSettings from '@/translations/en/proof-settings';

export default {
  title: 'Organisation details',
  subtitle: 'Organisation details and information',
  subtitle2: 'Provide the organisations basic details. Required fields are marked by *',
  createOrg: 'Create organisation',
  invitePending: 'Invite pending',
  owner: 'Owner',
  admin: 'Admin',
  member: 'Member',
  documentation: {
    title: 'Documentation',
    subtitle: 'Documentation to ensure organisational compliance',
    vatDoc: 'VAT Doc',
    proofOfAddress: 'Proof of Address',
    viewDoc: 'Open document in a new tab',
  },
  details: {
    name: 'Name',
    contactNumber: 'Contact number',
    email: 'Email address',
  },
  address: {
    line1: 'Street number',
    line2: 'Street name',
    line3: 'Suburb',
    city: 'City',
    stateProvince: 'Province',
    country: 'Country',
    postalCode: 'Area code',
  },
  addressPlaceholder: 'Enter organisation address',
  compliance: {
    title: 'Organisation compliance',
    subtitle: 'Complete organisation compliance documentation and details.',
    companyNhbrc: 'NHBRC registration no.',
    companyRegistration: 'Registration no.',
    companyVat: 'VAT registration no.',
  },
  users: {
    title: 'Users',
    subtitle: 'Add users to this organisation',
  },
  settings: {
    title: 'Organisation settings',
    info: {
      title: 'Key dates',
      content:
        'Important dates within your organisation for financial tracking and statement generation.',
    },
    labels: {
      financialYearEnd: 'Financial year end',
      financialYearEndTitle: 'Organisation financial year end',
      financialYearEndDescription: `An organization's financial year end marks the conclusion of its accounting period, when financial statements are prepared.`,
      vendorStatement: 'Vendor statement auto-generation',
      vendorStatementTitle: `Vendor statement auto-generation date`,
      vendorStatementDescription: `The date when an organization issues financial statements summarizing transactions and balances for its vendors.`,
      accountsPaymentDate: `Select accounts payment date`,
      accountsPaymentDateTitle: `Vendor accounts payment date`,
      accountsPaymentDateDescription: `The day each month when an organization processes all outstanding vendor payments.`,
    },
    proofSettings,
    unsavedChanges: 'You have unsaved changes.',
    keyDatesSaveFailed: 'Your key dates were not saved. Check your connection and save again.',
  },
  orgCreateSuccess: {
    title: 'Organisation created',
    content: 'Your organisation has been successfully created',
  },
  updateSuccess: {
    title: 'Organisation updated',
    content: 'Your organisation has been successfully updated',
  },
  deleteDocModal: {
    title: 'Delete document',
    message: 'Are you sure you want to delete this document?',
  },
  uploadDocSuccess: {
    title: 'Document uploaded',
    content: 'Document has been successfully uploaded',
  },
  deleteDocSuccess: {
    title: 'Document deleted',
    content: 'Document has been successfully deleted',
  },
  uploadLogoSuccess: {
    title: 'Logo uploaded',
    content: 'Logo has been successfully uploaded',
  },
  deleteLogoSuccess: {
    title: 'Logo deleted',
    content: 'Logo has been successfully deleted',
  },
};
